export default __webpack_public_path__ + "static/media/thumbnail.ee142a54.webp";